import React from 'react';
import { Skeleton } from '@skin-seoul/design-system';

export const LoyaltyBannerSkeletonMobile = () => {
  return (
    <div className="relative w-full h-[112px] rounded-[12px] bg-neutral-100 overflow-hidden">
      <div className="relative h-full flex items-center justify-between px-4 z-[1]">
        {/* Left Side - Title Skeleton */}
        <div className="flex flex-col gap-1">
          <Skeleton className="w-[80px] h-[20px]" />
          <Skeleton className="w-[100px] h-[20px]" />
        </div>

        {/* Right Side - Points Skeleton */}
        <Skeleton className="w-[100px] h-[32px]" />
      </div>
    </div>
  );
};
